// tslint:disable
import { Injector } from '@angular/core';

import { CMFormComponent } from '../../../component/cmform/cmform.component';

export class CMFormExecComponent extends CMFormComponent {

  constructor(_injector: Injector) {
    super(_injector);
  }

  public filter: any = {};
  private innerFilterConfig = {};
  public get filterConfig() {
    return this.innerFilterConfig;
  }
  public set filterConfig(value: any) {
    this.innerFilterConfig = value;
    this.filter = {};
    this.generateEmptyModel(value, this.filter);
  }

  valid() {
    return super.valid(this.filterConfig, this.filter);
	}

	innerExec() {
	}

  exec() {
    if (this.valid())
      this.innerExec();
  }

}